var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8971 9.39714L12.3971 16.8971C12.2917 17.0025 12.1487 17.0616 11.9996 17.0616C11.8506 17.0616 11.7076 17.0025 11.6021 16.8971L4.10214 9.39714C4.00278 9.29051 3.94869 9.14948 3.95126 9.00375C3.95383 8.85802 4.01286 8.71898 4.11592 8.61592C4.21898 8.51287 4.35802 8.45383 4.50375 8.45126C4.64947 8.44869 4.79051 8.50278 4.89714 8.60214L11.9996 15.7037L19.1021 8.60214C19.2088 8.50278 19.3498 8.44869 19.4955 8.45126C19.6413 8.45383 19.7803 8.51287 19.8834 8.61592C19.9864 8.71898 20.0455 8.85802 20.048 9.00375C20.0506 9.14948 19.9965 9.29051 19.8971 9.39714Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.a1ea812136ffaed660c48ec1951b9c07.svg";
export { ForwardRef as ReactComponent };